var React = require('react');

function VyOs (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Vector"},[React.createElement("path",{"d":"M37.3967 6.62H45.0467V32.12H51.1667V0.5H37.3967V6.62Z","fill":"#E0E7F6","key":0}),React.createElement("path",{"d":"M31.7867 0.5H0.166748V14.27H6.28675V6.62H31.7867V0.5Z","fill":"#E0E7F6","key":1}),React.createElement("path",{"d":"M6.28675 19.88H0.166748V51.5H13.9367V45.38H6.28675V19.88Z","fill":"#E0E7F6","key":2}),React.createElement("path",{"d":"M19.5467 45.38V51.5H51.1667V37.73H45.0467V45.38H19.5467Z","fill":"#E0E7F6","key":3}),React.createElement("path",{"d":"M11.3867 11.72H17.5067L28.7267 40.28H22.6067L11.3867 11.72Z","fill":"#E0E7F6","key":4}),React.createElement("path",{"d":"M39.9467 11.72H33.8267L22.6067 40.28H28.7267L39.9467 11.72Z","fill":"#E0E7F6","key":5})]));
}

VyOs.defaultProps = {"width":"52","height":"52","viewBox":"0 0 52 52","fill":"none"};

module.exports = VyOs;

VyOs.default = VyOs;
